// API Client with Dynamic Frontend URL Header
import axios from "axios";

// Get current frontend URL dynamically
const getCurrentFrontendUrl = () => {
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return "http://localhost:3000"; // Fallback for SSR
};

// Create axios instance with dynamic frontend URL header
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001",
  timeout: 30000,
});

// Request interceptor to add dynamic frontend URL
apiClient.interceptors.request.use(
  (config) => {
    // Add custom header with current frontend URL
    config.headers["X-Frontend-URL"] = getCurrentFrontendUrl();

    // Add auth token if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log(
      `🔗 [API] Sending frontend URL: ${config.headers["X-Frontend-URL"]}`
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;

// Utility function to get frontend URL for manual use
export const getFrontendUrl = getCurrentFrontendUrl;
